/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-tween-position.vue?vue&type=template&id=59d9f9e8&scoped=true&"
import script from "./add-tween-position.vue?vue&type=script&lang=ts&"
export * from "./add-tween-position.vue?vue&type=script&lang=ts&"
import style0 from "./add-tween-position.vue?vue&type=style&index=0&id=59d9f9e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9f9e8",
  null
  
)

export default component.exports